$( document ).ready(function() {

  // HEIGHT VIEWPORT
  const windowHeight = document.documentElement.clientHeight;
  document.documentElement.style.setProperty('--viewport-height', `${windowHeight}px`);
  $( window ).on( "resize", function() {
    // HEIGHT VIEWPORT
    const windowHeight = document.documentElement.clientHeight;
    document.documentElement.style.setProperty('--viewport-height', `${windowHeight}px`);
  });

  // FADE IN/OUT
  window.addEventListener("beforeunload", function () {
    $("body").addClass("fade-out");
  });
  window.addEventListener("pageshow", function() {
    setTimeout(function(){
    	$("body").removeClass("fade-out");
    }, 250);
  }, false);
  setTimeout(function(){
    $("body").removeClass("fade-out");
  }, 500);

  // LAZY LOADING
  var L = [].slice.call(document.querySelectorAll('.lazy'));
  if('IntersectionObserver' in window){
    let o = new IntersectionObserver(function(E, observer){
      E.forEach(function(e){
        if(e.isIntersecting){
          let l = e.target;
          if(l.tagName == 'IMG'){
            setTimeout(function(){
              l.src = l.dataset.src;
            }, 500);
          }
          if(l.tagName == 'VIDEO'){
            var P = l.play();
            if(P !== undefined){
              P.catch(error => {
                l.controls = true;
                l.classList.add('no-autoplay');
              });
            }
          }
          l.classList.remove('lazy');
          o.unobserve(l);
        }
      });
    });
    L.forEach(function(l){
      o.observe(l);
    });
  }

  // UPDATE CART COUNT
  function updateCartCount() {
    jQuery.getJSON('/cart.js', function(cart) {
      let itemscount = cart.item_count;
      var totalmoney = cart.total_price;
      totalmoney = totalmoney.toString().slice(0,-2);
      var len = totalmoney.length;
      var symbol = $("#mini-cart").attr("data-symbol");
      var x = totalmoney.substring(0, len-3) + "," + totalmoney.substring(len-3);
      if(len < 4){
        $("#total-price-minicart").text(symbol + totalmoney);
      } else {
        $("#total-price-minicart").text(symbol + x);
      }
      if(itemscount == 0){
        $( "#cart-trigger" ).click();
        $("#cart-trigger").addClass("disabled");
        $("#mini-cart").prepend("<p class='empty-cart-text'>Your bag is empty</p>");
      } else {
        $("#cart-trigger").removeClass("disabled");
      }
      $("#cart-trigger-number").text(itemscount);
    });
  }
  // ADD PRODUCT
  function incrementValue(e) {
    e.preventDefault();
    var fieldName = $(e.target).data('field');
    var parent = $(e.target).parent('div');
    var currentVal = parseInt(parent.find('input[name="updates[]"]').val(), 10);
    var id = $(e.target).data('id');
    var maxinv = $(e.target).data("inventory")
    console.log(maxinv);

    if(currentVal >= maxinv) {
      console.log("No more stock");
    } else {
      if (!isNaN(currentVal)) {
        parent.find('input[name="updates[]"]').val(currentVal + 1);
        parent.find('.quantity-wrap').text(currentVal + 1);
        jQuery.post('/cart/change.js', {
          quantity: currentVal + 1,
          id: id
        });
      } else {
        parent.find('input[name="updates[]"]').val(0);
        parent.find('.quantity-wrap').text(0);
        jQuery.post('/cart/change.js', {
          quantity: 0,
          id: id
        });
      }
    }
    
    setTimeout(function(){
      updateCartCount();
    }, 500);
  }
  // REMOVE PRODUCT
  function decrementValue(e) {
    e.preventDefault();
    var fieldName = $(e.target).data('field');
    var parent = $(e.target).parent('div');
    var cartitem = $(e.target).closest(".mini-cart-item");
    var currentVal = parseInt(parent.find('input[name="updates[]"]').val(), 10);
    var id = $(e.target).data('id');
    
    if (!isNaN(currentVal) && currentVal > 1) {
      parent.find('input[name="updates[]"]').val(currentVal - 1);
      parent.find('.quantity-wrap').text(currentVal - 1);
      jQuery.post('/cart/change.js', {
        quantity: currentVal - 1,
        id: id
      });
    } else {
      parent.find('input[name="updates[]"]').val(0);
      parent.find('.quantity-wrap').text(0);
      jQuery.post('/cart/change.js', {
        quantity: 0,
        id: id
      });
      cartitem.remove();
    }
    setTimeout(function(){
      updateCartCount();
    }, 500);
  }

  // TOGGLE CONTACT
  $( ".contact-close" ).click(function() {
    $("body").addClass("hide-contact-bar");
  });

  // TOGGLE MENU
  $( "#mobile-menu-trigger, #close-menu" ).click(function() {
    $("body").toggleClass("show-menu");
  });

  // TOGGLE MINICART
  $( "#mini-cart-close-mobile" ).click(function() {
    $( "#mini-cart" ).removeClass("active").slideUp(300);
    $( "#menu-container" ).removeClass("show");
    $( "#cart-trigger" ).removeClass("active");
    $("body").removeClass("black-menu");
    $('#menu-mobile').removeClass('show');
    $("#burger").removeClass("active");
  });
  $( "#cart-trigger" ).click(function() {
    $( "#mini-cart" ).toggleClass("active");
    $( "#menu-container" ).removeClass("show");
    $( "#cart-trigger" ).toggleClass("active");
    $("body").removeClass("black-menu");
    $('#menu-mobile').removeClass('show');
    $("#burger").removeClass("active");
    $('#newin-container, #collection-container, #shop-container, #search-form, #about-container, #contact-container').slideUp(300);
    if($("#menu-mobile").is(".active")){
      $("#menu-trigger-mobile").children("span").toggle();
      $("#menu-mobile").slideUp().removeClass("active");
    }
  });

  // FOOTER
  $( "#footer-credits-trigger" ).click(function() {
    $('#footer-credits').slideToggle(300);
  });
    
  // MENU MOBILE
  $( "#burger" ).click(function() {
    $("body").toggleClass("black-menu");
    $('#menu-mobile').toggleClass('show');
    $(this).toggleClass("active");
    $( "#mini-cart" ).removeClass("active");
  });

  // $( ".collection-link" ).hover(
  //   function() {
  //     var img = $(this).attr("data-img")
  //     if(img != ""){
  //       console.log("Contiene", img);
  //       $("<div class='hover-image-menu'><img src='" + img + "'></div>").appendTo( $(this).parent() );
  //     }
  //   }, function() {
  //     $(".hover-image-menu").remove();
  //   }
  // );

  $('.footer-link[href="/pages/about"]').click(function() {
    event.preventDefault();
    $("#about-container").appendTo("#header");
    $("#about-container").slideDown(300);
    $('#newin-container, #collection-container, #shop-container, #search-form, #contact-container').slideUp(300);
    $("#mini-cart").removeClass("active").slideUp(300);
    if($("#menu-mobile").is(".active")){
      $("#menu-trigger-mobile").children("span").toggle();
      $("#menu-mobile").slideUp().removeClass("active");
    }
  });

  $("#shop-label-mobile, #newin-label-mobile, #collection-label-mobile").click(function() {
    $(".nav-item-content").slideDown(300);
    $("#about-container, #search-form").slideUp(300);
  });

  $('#about-trigger-mobile').click(function() {
    event.preventDefault();
    if ($('#about-container').is(':visible')) {
        $(".nav-item-content").slideDown(300);
    } else {
        $(".nav-item-content, #search-form").slideUp(300);
    }
    $("#about-container").insertAfter($(this));
    $("#about-container").slideToggle(300);
  });

  var windowWidth = $(window).width();
  
  $('.footer-link[href="/pages/contact"], #contact-close').click(function() {
    event.preventDefault();
    if(windowWidth < 821){
      $("#contact-container").insertAfter($(this));
    }
    $('#newin-container, #collection-container, #shop-container, #search-form, #about-container').slideUp(300);
    $('#contact-container').slideToggle(300);
    $( "#mini-cart" ).removeClass("active").slideUp(300);
    if($("#menu-mobile").is(".active")){
      $("#menu-trigger-mobile").children("span").toggle();
      $("#menu-mobile").slideUp().removeClass("active");
    }
  });

  // MENU MOBILE
  $("#menu-trigger-mobile").click(function() {
    $(this).children("span").toggle();
    $("#menu-mobile").slideToggle().toggleClass("active");
  });
  
  // HIGHLIGHT CHANGE IMAGE MOBILE
  $(".homepage-highlight-image").click(function() {
    event.preventDefault();
    var windowWidth = $(window).width(),
        href = $(this).parent().parent('.homepage-highlight-link').attr('href'),
        el = $(this),
        src = el.attr("src");
    if(windowWidth <= 820){
      el.parent().parent().parent().children(".homepage-highlight-mobile").children(".highlight-module").children(".homepage-highlight-image").attr("src", src);
    } else {
      window.location.href = href;
    }
  });

  // MOBILE FILTERS
  $("#mobile-filters-trigger, #close-filters").click(function() {
    $("body").toggleClass("show-filters");
  });

  // SEARCH
  const searchForm = document.querySelector('.search-form');
  const searchInput = document.querySelector('.search-input-text');
  const activePlaceholder = "Escribe aquí lo que estés buscando";
  const defaultPlaceholder = "Buscar";
  function toggleActiveClass() {
    if (searchInput.value.trim() !== '' || document.activeElement === searchInput) {
      searchForm.classList.add('active');
      searchInput.setAttribute('placeholder', activePlaceholder);
    } else {
      searchForm.classList.remove('active');
      searchInput.setAttribute('placeholder', defaultPlaceholder);
    }
  }
  searchInput.addEventListener('focus', toggleActiveClass);
  searchInput.addEventListener('input', toggleActiveClass);
  searchInput.addEventListener('blur', toggleActiveClass);


  // TRATAMIENTOS MENU
  function moveTratamientos() {
    ww = $(window).width();
    if(ww < 821){
      $("#trata-menu").insertAfter("#menu .menu-row:nth-child(1)");
    } else {
      $("#trata-menu").appendTo("#sticky-header");
    }
  }
  moveTratamientos();
  $(window).resize(function () { 
    moveTratamientos();
  });
  $("#trata-trigger, #tratamientos-overlay").on('click', function() {
    $("body").toggleClass("show-trata");
    // if(ww < 821){
    //   $("#trata-menu").insertAfter("#menu .menu-row:nth-child(1)");
    // } else {
    //   $("#trata-menu").appendTo("#sticky-header");
    // }
  });
  $(".search-trigger").on('click', function(event) {
    $('.menu-row-search').toggleClass("show-search");
    $('.search-field').focus();
  });
  $('.parent-zona').hover(function () {
    var el = $(this),
        id = el.data("id");
        console.log(id);
    $('.child-zona, .parent-zona, .zona-posts, .zona').removeClass("active");
    el.addClass('active');
    $('.child-zona[data-id="' + id + '"]').addClass("active");
  });
  $('.zona').hover(function () {
    var el = $(this),
        id = el.data("id");
        console.log(id);
    $('.zona, .zona-posts').removeClass("active");
    el.addClass('active');
    $('.zona-posts[data-id="' + id + '"]').addClass("active");
  });
  $(document).keyup(function(e) {
    if (e.key === "Escape") {
      $("body").removeClass("show-trata");
    }
  });
  
});

















